module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-27798167f4987f830688da234fdc24ef.png";